// @ts-nocheck
import { BlockParsedBaseProps } from "@store/Library/Components/Toolkit/Block/Block";
import { BlockVariantBaseProps, BlockVariantTypeProps } from "@store/Library/Components/Toolkit/Block/variant/base";
import { clearfixStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface BlockVariantBackgroundBaseProps {}
export interface BlockVariantBackgroundProps extends BlockVariantBaseProps, BlockVariantBackgroundBaseProps {}

const typeProps: BlockVariantTypeProps<BlockVariantBackgroundProps> = {
    defaultProps: {},
    staticProps: {
        containerCss: css<BlockParsedBaseProps>`
            ${clearfixStyles()}
        `,
    },
};

export default typeProps;
